let ConhecimentosData = {
    Titulo: "Conhecimentos",
    sub: [
        {
            subtitulo: 'Programação',
            item: ['Linguagem C/C++', 'Node', "Python"]
        },
        {
            subtitulo: "Outros",
            item: ["Linux Ubuntu", 'Markdown']
        }

    ]
}

export default ConhecimentosData